import { createDynamicSlice } from ".";
import { getDashboardDetailsThunk } from "../thunks/dashboardThunk";

export const dashboardSlice = createDynamicSlice({
  name: "dashboard",
  thunk: getDashboardDetailsThunk,
  listMode: false,
  resetActionName: "resetDashboard",
});

export const dashboardReducer = dashboardSlice.reducer;
export const { resetDashboard } = dashboardSlice.actions;
